import { Component } from '@angular/core';
import { OnyxLogoComponent } from '../../logo/onyx-logo/onyx-logo.component';

@Component({
  selector: 'onyx-splash-screen',
  imports: [OnyxLogoComponent],
  templateUrl: './onyx-splash-screen.component.html',
  styleUrl: './onyx-splash-screen.component.scss',
})
export class OnyxSplashScreenComponent {}
